<script lang="ts">
	import { dev } from '$app/env';
	import { adminStore } from '#lib/stores/admin.js';
	import {
		diagnosticsStore,
		errorCount,
		openDiagnostics,
		warningCount
	} from '#lib/stores/diagnostics.js';
	import { t } from '#lib/stores/i18n.js';
	import { Activity } from '@lucide/svelte';
	import { scale } from 'svelte/transition';

	let count = $derived($errorCount > 0 ? $errorCount : $diagnosticsStore.length);
	let isError = $derived($errorCount > 0);
	let isWarning = $derived(!isError && $warningCount > 0);
	let isVisible = $derived(dev || ($adminStore && $diagnosticsStore.length > 0));
</script>

{#if isVisible}
	<button
		type="button"
		class="fixed bottom-5 right-20 z-40 flex items-center gap-2 px-3.5 py-2.5 rounded-full text-white font-medium text-xs shadow-xl backdrop-blur-md cursor-pointer transition-all duration-200 hover:scale-105 active:scale-95 focus:outline-none focus:ring-2 focus:ring-offset-2 {isError
			? 'bg-red-600 hover:bg-red-700 shadow-red-600/40 ring-red-400/50 focus:ring-red-500'
			: isWarning
				? 'bg-amber-600 hover:bg-amber-700 shadow-amber-600/40 ring-amber-400/50 focus:ring-amber-500'
				: 'bg-[#007ac2] hover:bg-[#006aa9] shadow-[#007ac2]/40 ring-sky-400/50 focus:ring-sky-500'}"
		transition:scale={{ duration: 200 }}
		onclick={(e) => {
			e.preventDefault();
			e.stopPropagation();
			openDiagnostics();
		}}
		aria-label={$t('diagnostics.floating_button')}
		title="{$t('diagnostics.floating_button')} ({$t('diagnostics.shortcut')})"
	>
		<Activity class="w-4 h-4 shrink-0 {isError ? 'animate-pulse' : ''}" />
		<span
			class="font-bold tabular-nums bg-black/25 px-1.5 py-0.5 rounded-full text-2xs min-w-4.5 text-center"
		>
			{count}
		</span>
	</button>
{/if}
